'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'maintenanceKind', 'MaintenanceKindService', 'StatusService',
    function ($scope, $modalInstance, maintenanceKind, MaintenanceKindService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.maintenanceKind = angular.copy(maintenanceKind);

            // Создание вида сопровождения проекта
            if (maintenanceKind == null || angular.equals({}, maintenanceKind) || maintenanceKind.id == null) {
                $scope.title = "Создание нового вида сопровождения проекта";
            } else {
                $scope.title = "Редактирование вида сопровождения проекта \"" + $scope.maintenanceKind.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.maintenanceKind.status) {
                    $scope.maintenanceKind.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.maintenanceKind);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                MaintenanceKindService.api.isUniqueName({name: name}, {id: $scope.maintenanceKind.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion

    }];